import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">

      <div className="footer-container">

        {/* LEFT SIDE */}
        <div className="footer-about">
          <h2 className="footer-logo">NamoDigital Hub</h2>

          <p className="footer-text">
            We help brands grow digitally with powerful marketing strategies,
            high-converting websites, and data-driven campaigns that deliver real results.
          </p>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-links">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>

        {/* SERVICES LINKS */}
        <div className="footer-links">
          <h3>Services</h3>
          <ul>
            <li><a href="/services">Web Development</a></li>
            <li><a href="/services">SEO Optimization</a></li>
            <li><a href="/services">Social Media Marketing</a></li>
            <li><a href="/services">Meta Ads</a></li>
          </ul>
        </div>

        {/* CONTACT */}
        <div className="footer-contact">
          <h3>Contact Us</h3>
          <p>Email: namodigitalhub@gmail.com</p>
          <p>Phone: +91 70330 06888</p>
          <p>India</p>

          {/* SOCIAL ICONS */}
          <div className="footer-socials">
            <a href="https://www.facebook.com/share/1CosMw2VHY/" target="_blank" rel="noreferrer"><i className="fab fa-facebook-f"></i></a>
            <a href="https://www.instagram.com/namodigitalhub?igsh=MWRjMGV6Z2d1a2pkdg==" target="_blank" rel="noreferrer"><i className="fab fa-instagram"></i></a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer"><i className="fab fa-linkedin-in"></i></a>
          </div>
        </div>

      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        <p>© 2026 NamoDigital Hub. All rights reserved.</p>
      </div>

    </footer>
  );
}

export default Footer;